export const version = 'v2.2.4-2033-g0d40a1123'
